angular.module('pitch.media')
.factory('DownloadHandler', function(DownloadModal, Download, $window, growl, $rootScope, MediaFilter) {
    'use strict';
    return function(e, subjects, params, context) {
        params = params || {};
        params.subjects = subjects;
        params.filteredSubjects = $rootScope.filteredSubjects || subjects;
        params.flacfilteredSubjects = $rootScope.flacfilteredSubjects || 0;

        MediaFilter.request({'subjects': subjects, 'format': 'wav'}, function(resp) {
                $rootScope.$broadcast('MEDIA_WAV', {subjects: resp.subjects, filteredSubjects: resp.filtered_subjects});
            }, function() {
                growl.error('We\'re very sorry but something went wrong discovering if wav files are available. Please try again later.');
                $rootScope.filteredSubjects = params.filteredSubjects = 0;
            }
        );

        MediaFilter.request({'subjects': subjects, 'format': 'flac'}, function(resp) {
                $rootScope.$broadcast('MEDIA_FLAC', {subjects: resp.subjects, filteredSubjects: resp.filtered_subjects});
            }, function() {
                growl.error('We\'re very sorry but something went wrong discovering if flac files are available. Please try again later.');
                $rootScope.flacfilteredSubjects = params.flacfilteredSubjects = 0;
            }
        );

        var success = function(args) {
            var modalResp = args[1];

            switch (modalResp.format) {
                case 'mp3':
                    subjects = subjects.map(function(subject) {
                        return subject.id;
                    });
                    break;
                case 'wav':
                    subjects = params.filteredSubjects;
                    break;
                case 'flac':
                    subjects = params.filteredSubjects; // this needs to change
                    break;
            }

            Download.save({
                format: modalResp.format,
                filename: params.filename,
                subjects: subjects,
                context: context
            }, function(resp) {
                if (resp.status === 'READY') {
                    $rootScope.$emit('MEDIA_DOWNLOAD_READY', resp);
                }
                if (resp.status === 'QUEUED') {
                    $rootScope.$emit('MEDIA_DOWNLOAD_ENQUEUED', resp);
                }
            }, function() {
                growl.error('We\'re very sorry but something went wrong. Please try again later.');
            });

            deregisterlistener();
            deregisterFlaclistener();
        };

        var deregisterlistener = $rootScope.$on('MEDIA_WAV', function(event, data) {
            params.filteredSubjects = data.filteredSubjects;
        });

        var deregisterFlaclistener = $rootScope.$on('MEDIA_FLAC', function(event, data) {
            params.flacfilteredSubjects = data.filteredSubjects;
        });

        DownloadModal.open({
                success: success
            },params);
    };
});



// WEBPACK FOOTER //
// ./src/MediaClientBundle/Resources/js/angular/services/DownloadHandler.js